import { Injectable, inject } from '@angular/core';
import { HisBackendService } from 'hisng';
import { Observable } from 'rxjs';

/*
 * This service is only used for wsTest => personal-agreement.service.wsspec.ts
 */
@Injectable()
export class PersonalAgreementService {
    private backendService = inject(HisBackendService);


    getByPerson( personId: number ): Observable<any> {
        return this.backendService.getData( `api/v1/cs/psv/personalagreement/byPerson/${personId}` );
    }

}
